module.exports = __webpack_public_path__ + "static/media/empty_series_learn.adae51a0.svg";